"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./index60.js");var u=r.functionUncurryThis,e=u(1 .valueOf);exports.thisNumberValue=e;
